import React from 'react';
import MDBox from '../../../shared/atoms/MDBox';

interface RouteLoadingContainerProps {
  children: React.ReactNode;
  fullScreen?: boolean;
  minHeight?: string | number;
}

const RouteLoadingContainer: React.FC<RouteLoadingContainerProps> = ({ 
  children, 
  fullScreen = true,
  minHeight = '100vh'
}) => {
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={fullScreen ? minHeight : 'auto'}
      p={3}
      sx={{
        background: (theme) => theme.palette.background.default,
        ...(fullScreen && {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000,
        })
      }}
    >
      {children}
    </MDBox>
  );
};

export default RouteLoadingContainer;